import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { FeeModel, FeeHistoryModel } from '../../models/fee.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeesService {
  private readonly baseUrl = `${environment.apiUrl}/api/admin/fees`;

  constructor(private readonly http: HttpClient) {}

  getFees(): Observable<FeeModel[]> {
    return this.http.get<FeeModel[]>(this.baseUrl);
  }

  getFeeDetail(id: number): Observable<{ fee: FeeModel; history: FeeHistoryModel[] }> {
    return this.http.get<any>(`${this.baseUrl}/${id}`).pipe(
      map(response => {
        // Backend returns flat object with history inside; separate fee from history
        const { history, ...fee } = response;
        return { fee: fee as FeeModel, history: (history ?? []) as FeeHistoryModel[] };
      })
    );
  }

  updateFee(id: number, data: Partial<FeeModel>): Observable<FeeModel> {
    return this.http.put<FeeModel>(`${this.baseUrl}/${id}`, data);
  }
}
